import script from "./MostrarEstructura.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostrarEstructura.vue?vue&type=script&setup=true&lang=ts"

import "./MostrarEstructura.vue?vue&type=style&index=0&id=3cd8d118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd8d118"]])

export default __exports__